import { render, staticRenderFns } from "./WashroomFrequencyView.vue?vue&type=template&id=2dcb8505&scoped=true"
import script from "./WashroomFrequencyView.vue?vue&type=script&lang=js"
export * from "./WashroomFrequencyView.vue?vue&type=script&lang=js"
import style0 from "./WashroomFrequencyView.vue?vue&type=style&index=0&id=2dcb8505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb8505",
  null
  
)

export default component.exports